// extracted by mini-css-extract-plugin
export default {"badge":"CallDirectionBadge_badge__b07Nq","inbound":"CallDirectionBadge_inbound__fRrHy","outbound":"CallDirectionBadge_outbound__K5lV1"};